import Alert from '../Alert/Alert';

function WarningMessage(props) {
    return (
        <>
            {props.warn.map((data, key) => {
                const message = data.message ? data.message : data;
                return (
                    <Alert key={key} variant="warning" body={message} />
                );
            })}
        </>
    );
}

export default WarningMessage;